import React from 'react'
import translate from '../../../utilities/translate'
import translations from './translations'
import styles from './CookiePreferencesButton.module.css'
import PropTypes from 'prop-types'
import { getLocales } from '../../../utilities/locales'

// trans :: String -> String -> String
const trans = translate(translations)

const CookiePreferencesButton = ({ locale, toggleInfoDisplay }) =>
  <button onClick={ toggleInfoDisplay } className={ styles.button }>
    { trans(locale)('label') }
  </button>

CookiePreferencesButton.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  toggleInfoDisplay: PropTypes.func.isRequired,
}

export default CookiePreferencesButton
